var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.27 18.5392C12.883 18.5389 14.4495 17.9989 15.7202 17.0053L19.715 21L21 19.7151L17.0051 15.7204C17.9993 14.4498 18.5396 12.883 18.54 11.2696C18.54 7.26133 15.2785 4 11.27 4C7.26151 4 4 7.26133 4 11.2696C4 15.2779 7.26151 18.5392 11.27 18.5392ZM11.27 5.8174C14.2771 5.8174 16.7225 8.26272 16.7225 11.2696C16.7225 14.2765 14.2771 16.7218 11.27 16.7218C8.26295 16.7218 5.8175 14.2765 5.8175 11.2696C5.8175 8.26272 8.26295 5.8174 11.27 5.8174Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0105f004b25814205e5cea3d595a37cf.svg";
export { ForwardRef as ReactComponent };